<template id="PrivacyIcon">
  <span>
    <span v-if="isPublic">
      <span class="fa fa-lock" v-b-tooltip.hover title="Private"></span>
    </span>
    <span v-else>
      <span class="fa fa-unlock" v-b-tooltip.hover title="Public"></span>
    </span>
  </span>
</template>

<script>
export default {
  name: "PrivacyIcon",
  props: {
    isPublic: Boolean,
  },
};
</script>
